export enum EnumStatus {
    Created = 0,
    Triggered,
    Postponed = 2,
    Changed = 4,
    Workflow = 8,
    Document = 16,
    SignedOff = 32,
    Done = 126,
}

export enum MediaType {
    Unknown,
    Document,
    Image,
    Video,
    Audio,
    Resource
}

export class Media {
    id: string = "";
    uri: string | undefined;
    filename: string = "";
    contentType: string = "";
    fKCellId: number | undefined;
    size: number = 0;
    type: MediaType | undefined;
    properties: string | undefined;
    sizePrettyPrint: string = "";
}
